import { authenticate, useSessionStore } from '@/entities/session';
import { configureHttp } from '@/shared/api';
import { env } from '@/shared/config';

import { demoResponder } from '../demo/demo-api';

/**
 * Связка транспорта с сессией.
 *
 * Живёт в слое app, потому что это единственное место, где можно свести
 * `shared/api` и `entities/session`, не нарушив направление зависимостей FSD.
 */
export function configureApi(): void {
  configureHttp({
    getToken: () => useSessionStore.getState().accessToken,
    refreshToken: authenticate,
    // Демо-заглушка подключается здесь, а не в shared: данные доменные,
    // и в shared им нельзя (FSD). В прод-сборке env.demo — константа false,
    // и весь модуль заглушки выпадает из бандла
    ...(env.demo ? { demo: demoResponder } : {}),
  });

  // ?welcome=1 в демо-режиме проверяет Welcome-модалку. isNewUser не
  // персистится, но токен — да, и с сохранённым токеном бутстрап не зовёт
  // /auth/telegram заново, где isNewUser считается. Сброс токена заставляет
  // залогиниться ещё раз и увидеть модалку без ручной чистки localStorage.
  if (env.demo && new URLSearchParams(window.location.search).has('welcome')) {
    useSessionStore.setState({ accessToken: null });
  }
}
